import React, { useContext, useEffect, useState } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import {
  Box,
  Link,
  Button,
  Heading,
  Image,
  IconButton,
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  useBreakpointValue,
  Flex,
  Spacer
} from '@chakra-ui/react';
import { HamburgerIcon } from '@chakra-ui/icons';
import { useAuth } from '../context/Auth.context';
import { useLogoutContext } from '../context/LogoutContext';
import { useLoginContext } from '../context/LoginContext';

const Navbar = () => {
  const { isAuthed, user } = useAuth();
  const isAdmin = user?.roles?.includes('admin');

  const { logoutMessage } = useLogoutContext();
  const { loginMessage } = useLoginContext();

  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    if (logoutMessage || loginMessage) {
      setIsVisible(true);
      const timer = setTimeout(() => setIsVisible(false), 2500);
      return () => clearTimeout(timer);
    }
  }, [logoutMessage, loginMessage]);

  const isMobile = useBreakpointValue({ base: true, md: false });

  return (
    <Box
      borderBottom="1px"
      borderColor="gray.700"
      position="sticky"
      top="0"
      p="4"
      px={['2', '4']}
      bg="black"
      zIndex="sticky"
    >
      {(logoutMessage || loginMessage) && (
        <Box
          position="fixed"
          top="20px"
          left="50%"
          transform="translateX(-50%)"
          bg="blue.500"
          color="white"
          px={6}
          py={3}
          borderRadius="lg"
          boxShadow="lg"
          transition="opacity 0.5s ease-out"
          opacity={isVisible ? 1 : 0}
          zIndex="9999"
        >
          {logoutMessage || loginMessage}
        </Box>
      )}

      <Flex align="center">
        {/* Logo & Titel links */}
        <Box display="flex" alignItems="center">
          <Image
            src="/images/logo.webp"
            alt="Beauty Alara Logo"
            boxSize="60px"
            mr="3"
          />
          <Heading
            as={RouterLink}
            to="/"
            my="0"
            fontWeight="500"
            fontSize={['1.5rem', '2rem']}
            fontFamily="Source Code Pro, monospace"
            color="white"
            _hover={{ textDecoration: 'none', color: 'gray.300' }}
          >
            Beauty ALARA
          </Heading>
        </Box>

        <Spacer />

        {/* Navigatie rechts */}
        <Box>
          {isMobile ? (
            <Menu>
              <MenuButton
                as={IconButton}
                icon={<HamburgerIcon />}
                variant="outline"
                color="white"
                _hover={{ bg: 'gray.600' }}
                aria-label="Open menu"
              />
              <MenuList bg="white" color="black">
                {isAdmin ? (
                  <>
                    <MenuItem as={RouterLink} to="/manage-appointments">
                      Afspraken beheren
                    </MenuItem>
                    <MenuItem as={RouterLink} to="/appointment">
                      Afspraak plannen
                    </MenuItem>
                    <MenuItem as={RouterLink} to="/closure">
                      Sluiting plannen
                    </MenuItem>
                  </>
                ) : (
                  <>
                    <MenuItem as={RouterLink} to="/appointment">
                      Afspraak plannen
                    </MenuItem>
                    <MenuItem as={RouterLink} to="/upcoming-appointments">
                      Afspraken beheren
                    </MenuItem>
                  </>
                )}
                <MenuItem as={RouterLink} to={isAuthed ? '/logout' : '/login'}>
                  {isAuthed ? 'Log uit' : 'Log in'}
                </MenuItem>
              </MenuList>
            </Menu>
          ) : (
            <Box display="flex" alignItems="center">
              {isAdmin ? (
                <>
                  <Button
                    as={RouterLink}
                    to="/manage-appointments"
                    color="white"
                    bg="gray.700"
                    _hover={{ bg: 'gray.600' }}
                    fontSize="lg"
                    mx="2"
                  >
                    Afspraken beheren
                  </Button>
                  <Button
                    as={RouterLink}
                    to="/appointment"
                    color="white"
                    bg="gray.700"
                    _hover={{ bg: 'gray.600' }}
                    fontSize="lg"
                    mx="2"
                  >
                    Afspraak plannen
                  </Button>
                  <Button
                    as={RouterLink}
                    to="/closure"
                    color="white"
                    bg="gray.700"
                    _hover={{ bg: 'gray.600' }}
                    fontSize="lg"
                    mx="2"
                  >
                    Sluiting plannen
                  </Button>
            </>
          ) : (
          <>
            <Button
              as={RouterLink}
              to="/appointment"
              color="white"
              bg="gray.700"
              _hover={{ bg: 'gray.600' }}
              fontSize="lg"
              mx="2"
            >
              Afspraak plannen
            </Button>
            <Button
              as={RouterLink}
              to="/upcoming-appointments"
              color="white"
              bg="gray.700"
              _hover={{ bg: 'gray.600' }}
              fontSize="lg"
              mx="2"
            >
              Afspraken beheren
            </Button>
          </>
              )}
          <Button
            as={RouterLink}
            to={isAuthed ? '/logout' : '/login'}
            color="white"
            bg="gray.700"
            _hover={{ bg: 'gray.600' }}
            fontSize="lg"
            mx="2"
          >
            {isAuthed ? 'Log uit' : 'Log in'}
          </Button>
        </Box>
          )}
    </Box>
      </Flex >
    </Box >
  );
};

export default Navbar;
